import React from 'react';

const WinningAnalysisCard = ({ analysis }) => (
  <article className="winning-archive-card">
    <div className="winning-archive-top">
      <span className="league">
        {analysis.match?.league?.country} - {analysis.match?.league?.name}
      </span>
      <span className="confidence high">%{analysis.confidenceScore || 0}</span>
    </div>

    <div className="winning-archive-top">
      <span className="hero-badge">{analysis.sourceType || 'AI Analiz'}</span>
      {analysis.outcome?.label ? <span className="winning-outcome-pill">{analysis.outcome.label}: {analysis.outcome.value}</span> : null}
    </div>

    <h3>
      {analysis.match?.homeTeam?.name} - {analysis.match?.awayTeam?.name}
    </h3>

    <div className="winning-archive-pick">
      <strong>{analysis.bestPrediction?.selection}</strong>
      <span>{analysis.bestPrediction?.market}</span>
      <span>%{analysis.confidenceScore || 0}</span>
    </div>

    <p className="analysis-summary">
      {analysis.narrative?.summary || 'Kazanan analiz arsive eklendi.'}
    </p>

    <div className="winning-coupon-items">
      {analysis.outcome?.finalScore ? (
        <div className="winning-coupon-item">
          <strong>Mac Sonu Skoru</strong>
          <span>{analysis.outcome.finalScore}</span>
        </div>
      ) : null}
      {analysis.outcome?.halftimeScore ? (
        <div className="winning-coupon-item">
          <strong>Ilk Yari Skoru</strong>
          <span>{analysis.outcome.halftimeScore}</span>
        </div>
      ) : null}
    </div>
  </article>
);

export default WinningAnalysisCard;
